import Box from '@mui/material/Box';
import EditableTextInput from '@features/EditableTextInput/ui/EditableTextInput';

interface TableDemandCellProps {
  value: string;
  id?: any;
  className?: string;
  onSuccess: () => void;
  isDocument?: boolean;
  documentType: string;
  updateFunction?: (
    id: number,
    filename: any,
    callback: (response: any) => void
  ) => Promise<void>;
  onClickCell?: () => void;
}

/**
 * @param value - The table cell value
 * @param id - Active demand id
 * @param documentType - Type of the document
 * @param className - Custom class name for demand cell container
 * @param isDocument - for checking document type
 * @param onSuccess - Function which is called after successful demand update
 * @param updateFunction - Function for updating document name depends on document type
 * @param onClickCell - Function called when the cell is clicked
 * @description a modal for demand table cell
 */

function TableDemandCell({
  value,
  id,
  documentType,
  className,
  isDocument,
  onSuccess,
  updateFunction,
  onClickCell = () => {},
}: TableDemandCellProps) {
  return (
    <Box
      onClick={onClickCell}
      sx={{
        display: 'flex',
        height: '100%',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <img src="/icons/document.svg" alt="Document" />
      <EditableTextInput
        onSuccess={onSuccess}
        document_type={documentType}
        isDocument={isDocument}
        size="small"
        value={value}
        demandId={id}
        wrapperClassName={className}
        editOnHover
        updateFunction={updateFunction}
      />
    </Box>
  );
}

export default TableDemandCell;
